import styled from 'styled-components'

type Props = {
  value: string
}

export default styled.div<Props>`
  margin-top: ${(props) => props.value};
`
